import { createFileRoute } from '@tanstack/react-router'
import { MorePage } from './-components/more-page'

export const Route = createFileRoute('/mrgolisoda/more/')({
  component: MorePage,
})
